import React from 'react';
import Ribbon from "@widgets/ribbon";
import Icon from "@widgets/icon/icon";
import RibbonSeparator from '@widgets/ribbon/ribbonSeparator';
export function AlertCard({ onConfirm, status, title, message }) {
    let alertIcon;
    switch (status) {
        case ('success'):
            alertIcon = {
                "iconClassName": "ltg-iconElektroninis-pastas",
                "iconName": "Elektroninis-pastas",
                "iconPack": "ltg-colored",
                "iconPrefix": "ltg-icon",
                "iconPackType": "icomoon"
            };
            break;
        case ('warning'):
            alertIcon = {
                "iconClassName": "ltg-iconInfocentras",
                "iconName": "Infocentras",
                "iconPack": "ltg-colored",
                "iconPrefix": "ltg-icon",
                "iconPackType": "icomoon"
            };
            break;
        default:
            alertIcon = {
                "iconClassName": "ltg-iconIspejimas",
                "iconName": "Ispejimas",
                "iconPack": "ltg-colored",
                "iconPrefix": "ltg-icon",
                "iconPackType": "icomoon"
            };
            break;
    }
    return (React.createElement("div", { className: "ltg-alert-card" },
        alertIcon && (React.createElement("div", { className: "text-center" },
            React.createElement(Icon, { icon: alertIcon, size: '4' }))),
        React.createElement("div", { className: "ltg-alert-card-section" },
            React.createElement("h1", { role: "presentation" }, title),
            !!message && (React.createElement("p", { dangerouslySetInnerHTML: { __html: message } })),
            React.createElement("div", { className: "text-center" },
                React.createElement("button", { onClick: onConfirm, autoFocus: true, className: "btn btn-primary btn-sm" }, "OK"))),
        ['museum'].includes(LTG_VARIABLES === null || LTG_VARIABLES === void 0 ? void 0 : LTG_VARIABLES.theme) ?
            React.createElement(RibbonSeparator, null)
            :
                React.createElement("div", { style: { display: 'flex', overflow: 'hidden' } },
                    React.createElement("div", { style: { width: 100 } },
                        React.createElement(Ribbon, { side: "left" })),
                    React.createElement("div", { style: { flex: 1 } },
                        React.createElement(Ribbon, { side: "right", color: "primary" })))));
}
